import React, { FC }                               from 'react';
import { CorvalBusinessFunction, SemanticUIColor } from '@src/types';
import { DotShape, DotShapeProps }                 from '../util/visual/DotShape';


interface Props extends Pick<DotShapeProps, 'size'> {
    businessFunction: CorvalBusinessFunction,
}

const defaultProps: Props = {
    size:             10,
    businessFunction: null,
};

const BusinessFunctionDot: FC<Props> = ( props ) => {

    return (

        <DotShape size={ props.size } color={ props.businessFunction?.colorValue ?? SemanticUIColor.GREY }/>
    );
};

BusinessFunctionDot.defaultProps = defaultProps;

export { BusinessFunctionDot };
